export type IExternalStorageProvider = ReturnType<
  typeof ExternalStorageProviderFactory
>;

export const ExternalStorageProviderFactory = ({
  APIProvider,
  AuthService,
  APIPath,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIPath: string;
}) => {
  const { POST } = APIProvider;
  const { getAuthenticationToken } = AuthService;

  const getFile: IGetFileFromExternalStorage = async ({ bucket, fileName }) => {
    const data = {
      bucket_name: bucket,
      file_name: fileName,
    };
    return POST(APIPath, data, {
      Authorization: `Bearer ${await getAuthenticationToken()}`,
    });
  };

  return {
    getFile,
  };
};
